import React from 'react'
import { Link } from 'react-router-dom';
import CategoryDetailsContent from '../../../components/Dashboard/Categories/View';

function CategoryDetails() {
    return (
        <>
          {/* Breadcrumb */}
          {/* <div className="breadcrumb-card">
            <h5>Categories Details</h5>
    
            <ul className="breadcrumb">
              <li>
                <Link to="/dashboard/ecommerce/"> 
                  <i className="material-symbols-outlined">home</i>
                  Dashboard
                </Link>
              </li>
              <li><Link to="/categories">
                  Categories
                </Link></li>
              <li>Categories Details</li>
            </ul>
          </div> */}
           
          <CategoryDetailsContent />
        </>
      );
}

export default CategoryDetails
